var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFurniture4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.571,
    height: 46.261,
    viewBox: "0 0 40.571 46.261",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7745",
    "data-name": "Grupo 7745",
    transform: "translate(-57.648 -51.215)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elipse_578",
    "data-name": "Elipse 578",
    transform: "translate(68 70)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 10,
    cy: 9.5,
    rx: 10,
    ry: 9.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10,
    cy: 9.5,
    rx: 9.5,
    ry: 9,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6736",
    "data-name": "Grupo 6736",
    transform: "translate(57.648 51.215)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8132",
    "data-name": "Caminho 8132",
    d: "M256.112,144.545H286.8a4.925,4.925,0,0,0,3.488-1.451l0,0a4.925,4.925,0,0,0,1.451-3.488V103.227a4.925,4.925,0,0,0-1.451-3.488l0,0a4.925,4.925,0,0,0-3.488-1.451H256.112a4.925,4.925,0,0,0-3.488,1.451l0,0a4.925,4.925,0,0,0-1.451,3.488V139.6a4.925,4.925,0,0,0,1.451,3.488l0,0A4.925,4.925,0,0,0,256.112,144.545Zm32.9-2.725a3.134,3.134,0,0,1-2.218.921H256.112a3.144,3.144,0,0,1-3.139-3.139V106.013h36.962V139.6A3.134,3.134,0,0,1,289.015,141.82Zm0-40.811a3.134,3.134,0,0,1,.921,2.218v.982H272.356v-4.12H286.8A3.134,3.134,0,0,1,289.015,101.009Zm-35.121,0a3.134,3.134,0,0,1,2.218-.921h14.44v4.12H252.973v-.982A3.134,3.134,0,0,1,253.894,101.009Z",
    transform: "translate(-251.169 -98.284)",
    fill: "#153c8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8133",
    "data-name": "Caminho 8133",
    d: "M265.151,119.263a.9.9,0,0,0-.9-.9h-4.735a.9.9,0,0,0,0,1.8h4.735A.9.9,0,0,0,265.151,119.263Z",
    transform: "translate(-254.277 -106.668)",
    fill: "#153c8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8134",
    "data-name": "Caminho 8134",
    d: "M288.772,139.208a9.781,9.781,0,0,0-19.507-1.085,5.406,5.406,0,0,0-.114,1.1s.005.007.005.011a9.78,9.78,0,0,0,19.506,1.087,5.371,5.371,0,0,0,.114-1.1C288.776,139.215,288.772,139.213,288.772,139.208Zm-9.808-7.993a8.005,8.005,0,0,1,8.005,8.006c0,.012,0,.023,0,.036a3.55,3.55,0,0,1-7.1-.036,5.3,5.3,0,0,0-7.063-5.055c.167-.2.315-.421.5-.606A7.98,7.98,0,0,1,278.964,131.215Zm0,16.01a8,8,0,0,1-8.005-8c0-.013,0-.024,0-.037a3.55,3.55,0,0,1,7.1.037,5.3,5.3,0,0,0,7.063,5.054c-.167.2-.314.421-.5.606A7.979,7.979,0,0,1,278.964,147.225Z",
    transform: "translate(-258.679 -111.282)",
    fill: "#153c8b"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFurniture4);
export default __webpack_public_path__ + "static/media/furniture-4.9b30ac1271258bd40ef2bfcb99b58d38.svg";
export { ForwardRef as ReactComponent };